import { createContext, useContext, useEffect, useState } from "react";
import { api, auth } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => auth.getUser());
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const tok = auth.getToken();
        if (tok) {
            api.get("/auth/me")
                .then((r) => {
                    setUser(r.data);
                    auth.saveSession(tok, r.data);
                })
                .catch(() => {
                    auth.clear();
                    setUser(null);
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        auth.saveSession(r.data.access_token, r.data.user);
        setUser(r.data.user);
        return r.data.user;
    };

    const register = async (payload) => {
        const r = await api.post("/auth/register", payload);
        auth.saveSession(r.data.access_token, r.data.user);
        setUser(r.data.user);
        return r.data.user;
    };

    const logout = () => {
        auth.clear();
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, setUser, loading, login, register, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
